// userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  isAuthenticated: false,
  loading: false,
  error: null,
  tokens: {
    accessToken: null,
    refreshToken: null
  }
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setUser: (state, action) => {
      const { user, accessToken, refreshToken } = action.payload;
      
      // MERGE user data instead of replacing
      state.user = {
        ...state.user,        // Keep existing user data
        ...user               // Merge new data
      };
      
      // Update tokens if provided
      if (accessToken !== undefined) {
        state.tokens.accessToken = accessToken;
      }
      if (refreshToken !== undefined) {
        state.tokens.refreshToken = refreshToken;
      }
      
      state.isAuthenticated = true;
      state.error = null;
      state.loading = false;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.tokens = {
        accessToken: null,
        refreshToken: null
      };
      state.error = null;
      state.loading = false;
    },
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    },
    clearError: (state) => {
      state.error = null;
    },
    setTokens: (state, action) => {
      state.tokens = { ...state.tokens, ...action.payload };
      if (action.payload.accessToken) {
        state.isAuthenticated = true;
      }
    }
  }
});

export const { 
  setLoading, 
  setUser, 
  setError, 
  logout, 
  updateUser,
  clearError,
  setTokens
} = userSlice.actions;

export default userSlice.reducer;